import React from 'react';
import useMemo from '@/util/hook/useMemo';
import Description from '../../component/atom/Description';
import Header from '../../component/atom/Header';
import Copy from '../../component/composite/Copy';
import RWDPageLayout from '../../component/composite/RWDPageLayout';
import { S } from './style';
import { APP } from '../../config/app';
import instructionGif from '../../asset/careOrderBabyTransfer.gif';
const renderHeader = () => (<Header progress={APP.PAGE_PROGRESS_INFO['/transferInstruction'].progress} progressTitle={APP.PAGE_PROGRESS_INFO['/transferInstruction'].title}/>);
const renderDescription = () => (<Description content={<>
        下一步：加入 Home心 LINE 帳號，輸入下方代號，即完成綁定。
        <br />
        綁定完成才能看到看護的申請唷！
      </>}/>);
const renderTransferStepsSection = ({ careOrderBabyCode, careOrderBabyExpirationTime, }) => (<S.LayoutSection>
    <div>
      <S.Title>第一步：複製案件代號</S.Title>
      <div>📍️ 此代號有效時間：{careOrderBabyExpirationTime}</div>
      <S.Gap height={10}/>
      <Copy content={careOrderBabyCode}/>
    </div>
    <div>
      <S.Title>第二步：加入LINE完成派案</S.Title>
      <S.LineButton data-v-6fa6a74a='' href='https://lin.ee/osZCxYS' target='_blank'>
        <img data-v-6fa6a74a='' src='https://scdn.line-apps.com/n/line_add_friends/btn/zh-Hant.png' alt='加入好友' height={56}/>
      </S.LineButton>
    </div>
  </S.LayoutSection>);
const renderInstructionGIFSection = () => (<S.LayoutSection isLast>
    <div>
      <S.Title>案件綁定教學</S.Title>
      <S.Img src={instructionGif} alt='transferInstruction'/>
    </div>
  </S.LayoutSection>);
export default function View({ 
// data
isLoading, careOrderBabyForTransferInstructionPage, }) {
    const careOrderBabyCode = careOrderBabyForTransferInstructionPage.code;
    const careOrderBabyExpirationTime = careOrderBabyForTransferInstructionPage.parsedExpirationTime;
    const header = useMemo(() => renderHeader(), []);
    const description = useMemo(() => renderDescription(), []);
    const transferStepsSection = useMemo(() => renderTransferStepsSection({
        careOrderBabyCode,
        careOrderBabyExpirationTime,
    }), [careOrderBabyCode, careOrderBabyExpirationTime]);
    const instructionGIFSection = useMemo(() => renderInstructionGIFSection(), []);
    return (<RWDPageLayout isLoading={isLoading}>
      {header}
      <S.Layout>
        {description}
        {transferStepsSection}
        {instructionGIFSection}
      </S.Layout>
    </RWDPageLayout>);
}
